/* eslint-disable camelcase */
import React from 'react';
interface ISegmentValues {
    userId: string;
    employer_id: string;
    login_method_type?: string;
    login_method?: string;
    commonMeta?: Record<string, unknown>;
    employer_name?: string;
}
const initialState = {
    userId: '',
    employer_id: '',
    login_method_type: '',
    login_method: ''
} as ISegmentValues;

const SegmentContext = React.createContext<ISegmentValues>(initialState);

type ISegmentType = 'page' | 'click' | 'identify' | 'task';
const useSegment = (
    type: ISegmentType,
    commonProperties?: Record<string, unknown>
): (({ name, properties }: { name: string; properties?: Record<string, unknown> }) => void) => {
    const userAgent = window.navigator.userAgent;
    const { userId, commonMeta = {}, ...rest } = React.useContext<ISegmentValues>(
        SegmentContext
    );
    if (type === 'page') {
        return ({ name, properties }: { name: string; properties?: Record<string, unknown> }) => {
            window.analytics.track(
                {
                    event: 'Viewed_' + name,
                    type,
                    properties: {
                        ...properties,
                        ...commonProperties,
                        form_name: name,
                        platform: 'Onboarding',
                        device_id: userAgent,
                        ...rest
                    }
                },
                {
                    traits: commonMeta
                }
            );
        };
    } else if (type === 'click') {
        return ({ name, properties }: { name: string; properties?: Record<string, unknown> }) =>
            window.analytics.track(
                {
                    event: 'Clicked_' + name,
                    type,
                    properties: {
                        ...properties,
                        ...commonProperties,
                        clicked_on: name,
                        form_name: name,
                        platform: 'Onboarding',
                        device_id: userAgent,
                        ...rest
                    }
                },
                {
                    traits: commonMeta
                }
            );
    } else if (type === 'identify') {
        return ({ name, properties }: { name: string; properties?: Record<string, unknown> }) => {
            const finalCommonProperties = { ...commonMeta, ...properties };
            window.analytics.identify(
                userId,
                {
                    ...finalCommonProperties,
                    platform: 'Onboarding',
                    event: 'IdentifyUser',
                    name: name,
                    ...rest
                },
                {
                    traits: finalCommonProperties,
                    platform: 'Onboarding',
                    event: 'IdentifyUser',
                    name: name,
                    ...rest
                }
            );
        };
    } else if (type === 'task') {
        return ({ name, properties }) =>
            window.analytics.track(
                {
                    event: name,
                    type,
                    properties: {
                        ...properties,
                        ...commonProperties,
                        platform: 'Onboarding',
                        ...rest
                    }
                },
                {
                    traits: commonMeta
                }
            );
    }
    return () => null;
};

export const SegmentProvider = SegmentContext.Provider;
export type { ISegmentValues };
export default useSegment;
